module.exports = __webpack_public_path__ + "media/images/web_suite/physan_icon-de897edab17096bdaf3fb23d98298ca0.png";